import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DefineMetricHint = styled.div`
  font-style: italic;
  color: ${globals.gray600};
  margin-top: 16px;
`;
